import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../Css/Login.css";
import { useAuth } from "../../Middleware/context/AuthContext";
import Spinner from "../Integration/Spinner";

function Login() {
  
  const [showRegister, setShowRegister] = useState(false);
  const { login, register } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [loginUser, setLoginUser] = useState({
    nome: "",
    idCard: "",
    email: "",
    telefone: "",
    password: "",
    confirmpassword: "",
  });

  const handleChange = (e) => {
    setLoginUser({ ...loginUser, [e.target.name]: e.target.value });
  };

  const handleLogin = async () => {
    try {


      setLoading(true);
      await login(loginUser.email, loginUser.password);
     
      navigate("/Home");
    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();

    if (loginUser.password !== loginUser.confirmpassword) {
      alert("As senhas não coincidem");
      return;
    }

    try {
      setLoading(true);
      await register(loginUser);
      navigate("/Home")
    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };



  return (
       <>
      {loading && <Spinner />}


    <div className="geral-sign-cad">
      {!showRegister ? (
        <div className="login-Geral">
          <div className="Main-login-container">
            <Link to="/Home">
              <div className="brand-logo"></div>
            </Link>
            <div className="brand-title">Tou Aki</div>
            <div className="div-inputs">
              <label className="lbl-login">E-mail</label>
              <input
                className="input-data"
                type="email"
                name="email"
                value={loginUser.email}
                onChange={handleChange}
                placeholder="example@test.com"
              />
              <label className="lbl-login">Password</label>
              <input
                className="input-data"
                type="password"
                name="password"
                value={loginUser.password}
                onChange={handleChange}
                placeholder="Min 6 characters long"
              />
              <button className="btn-submit" type="button" onClick={handleLogin}>
                Login
              </button>
              <button
                className="btn-submit"
                type="button"
                onClick={() => setShowRegister(true)}
              >
                Registrar
              </button>
            </div>
            <a
              className="a-href"
              href="https://www.facebook.com/Tou.Aki.E.Commerce"
            >
              Agora Tudo e Mais Facil
            </a>
          </div>
        </div>
      ) : (
        <div id="geralregister">
          <div className="register-container">
            <div className="back-title" onClick={() => setShowRegister(false)}>
              Back to Login
            </div>
            <div className="content">
              <form onSubmit={handleRegister}>
                <div className="user-details">
                  <div className="input-box">
                    <span className="details">Full Name</span>
                    <input
                      name="nome"
                      value={loginUser.nome}
                      onChange={handleChange}
                      className="inp-user"
                      type="text"
                      placeholder="Enter your name"
                      required
                    />
                  </div>
                  <div className="input-box">
                    <span className="details">ID Card</span>
                    <input
                      name="idCard"
                      value={loginUser.idCard}
                      onChange={handleChange}
                      className="inp-user"
                      type="text"
                      placeholder="000297278BO789"
                      required
                    />
                  </div>
                  <div className="input-box">
                    <span className="details">Email</span>
                    <input
                      name="email"
                      value={loginUser.email}
                      onChange={handleChange}
                      className="inp-user"
                      type="email"
                      placeholder="Enter your email"
                      required
                    />
                  </div>
                  <div className="input-box">
                    <span className="details">Phone Number</span>
                    <input
                      name="telefone"
                      value={loginUser.telefone}
                      onChange={handleChange}
                      className="inp-user"
                      type="text"
                      placeholder="Enter your number"
                      required
                    />
                  </div>
                  <div className="input-box">
                    <span className="details">Password</span>
                    <input
                      name="password"
                      value={loginUser.password}
                      onChange={handleChange}
                      className="inp-user"
                      type="password"
                      placeholder="Enter your password"
                      required
                    />
                  </div>
                  <div className="input-box">
                    <span className="details">Confirm Password</span>
                    <input
                      name="confirmpassword"
                      value={loginUser.confirmpassword}
                      onChange={handleChange}
                      className="inp-user"
                      type="password"
                      placeholder="Confirm your password"
                      required
                    />
                  </div>
                </div>
                <div className="button-div">
                  <button className="btn-cad" type="submit">
                    Register
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
        </>
  );
}

export default Login;
